import { ofType } from 'redux-observable';
import { timer } from 'rxjs';
import { debounce, map, switchMap } from 'rxjs/operators';

import { gqlRequest } from '../../helpers/request';
import { getAutocompleteUserListAction, setAutocompleteUserListAction } from '../slices/teamShare';

const queryGQL = `
  query hostedWatchSearchTeamList(
    $page: Int,
    $pageSize: Int,
    $sortBy: String,
    $sortOrder: String,
    $searchText: String,
    $searchIn: [String],
    $videoId: String!,
  ) {
    hostedWatchSearchTeamList(
      page: $page,
      pageSize: $pageSize,
      sortBy: $sortBy,
      sortOrder: $sortOrder,
      searchText: $searchText,
      searchIn: $searchIn,
      videoId: $videoId,
    ) {
      id,
      email,
      firstName,
      lastName,
    }
  }
`;

export default (action$) =>
  action$.pipe(
    ofType(getAutocompleteUserListAction.type),
    debounce(() => timer(500)),
    switchMap(({ payload }) => {
      const { searchText, searchIn, videoId } = payload;

      const queryParams = {
        page: 1,
        pageSize: 50,
        sortBy: 'firstName',
        sortOrder: 'asc',
        videoId,
      };

      if (searchText) {
        queryParams.searchText = searchText;
      }
      if (searchIn) {
        queryParams.searchIn = searchIn;
      }

      return gqlRequest({
        query: queryGQL,
        variables: queryParams,
      }).pipe(
        map(({ data, errors }) => setAutocompleteUserListAction(!errors.length ? data.hostedWatchSearchTeamList : [])),
      );
    }),
  );
